import React, { Component } from 'react'
import Navigator from './Navigation'
// import Vconsole from 'vconsole'
// import FastClick from 'fastclick'
import { isWeb } from './utils/tools'

class JDReactSHHouse extends Component{
	constructor (props) {
		super(props);
		this.state = {
			initRoute: this._getInitRoute()
		}
	}
	_getInitRoute() {

		let initRoute = {
			key: 'detailsPage',
			routeParams: {}
		};
		const {
			title='', 
			countyId='', 
			streetIds='', 
			minRentPrice='',
			maxRentPrice='',
			minTradePrice='',
			maxTradePrice='',
			roomAreaIds='',
			houseType='',
			subHouseType='',
			cityId=null,
			cityName=''
		} = this.props
		switch (this.props.routerName) {
			case 'detailsPage':
				initRoute.key = 'detailsPage';
				initRoute.routeParams = {
					parmkey: this.props.parmkey,
					skuId: this.props.skuId,
					isReport: this.props.isReport || 0
				};
				break;
			case 'houseDes':
				initRoute.key = 'houseDes';
				initRoute.routeParams = {parmkey: this.props.parmkey};
				break;
			case 'shopMap':
				initRoute.key = 'shopMap';
				initRoute.routeParams = {primaryKey: this.props.primaryKey};
				break;
			case 'zufang':
				initRoute.key = 'zufang';
				initRoute.routeParams = {};
				break;
			case 'zufangDetail':
				initRoute.key = 'zufangDetail';
				initRoute.routeParams = {skuId: this.props.skuId};
				break;
			case 'zufangList':
				initRoute.key = 'zufangList';
				initRoute.routeParams = {
					title, 
					countyId, 
					streetIds, 
					minRentPrice,
					maxRentPrice,
					minTradePrice,
					maxTradePrice,
					roomAreaIds,
					houseType,
					subHouseType,
					cityId,
					cityName
				};
				break;
			default:
				initRoute.key = 'zufang';
				initRoute.routeParams = {};
		}

		return initRoute;
	}
	componentDidMount () { 
		if (isWeb) {
			// new Vconsole()
			const FastClick = require('fastclick')
			FastClick.attach(document.body);
		}
	}

  render() {
    global.initprops = this.props;
    return (
        <Navigator initRoute={this.state.initRoute}/>
    );
  }
}
module.exports = JDReactSHHouse;
